import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database';
import "firebase/storage";
import "firebase/messaging";
import axios from 'axios';
import moment from 'moment';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
/*   console.log('conf ', config); */

firebase.initializeApp(config);

export const auths = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null

// messaging web 
/* if(messaging){
  messaging.usePublicVapidKey("BG7UAcf2F50TBldHp-_OmXD0-NmcXr1qG7H87f36AUC95p1nIBXy9iIM3W4awOyINgp3N-QGqxqU4Tt0TwAwPsk");


  messaging.requestPermission()
  .then(function(){
    console.log("have permision")
    return messaging.getToken();
  })
    .then(function(token){
      console.log(token)
    })
  .catch(function(err){
    console.log("errss", err)
  })

  messaging.onMessage(function(payload) {
    console.log(payload)
  })
}
 */

/* Social Sign In Method Provider */

const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });


const facebookProvider = new firebase.auth.FacebookAuthProvider();
facebookProvider.addScope('user_birthday');

export const doPersistence = (email, password) => auths.setPersistence(firebase.auth.Auth.Persistence.SESSION)

export const doSignInWithGoogle = () => auths.signInWithPopup(googleProvider)
export const doSignInWithFacebook = () => auths.signInWithPopup(facebookProvider)


export const doCreateUserWithEmailAndPassword = (email, password) =>
  auths.createUserWithEmailAndPassword(email, password);

export const doSignInWithEmailAndPassword = (email, password) =>
  auths.signInWithEmailAndPassword(email, password)

export const getCurrentUser = () => auths.currentUser

/* export const doSignInWithFacebook = () =>
auths.signInWithPopup(facebookProvider);

export const doSignInWithTwitter = () =>
auth.signInWithPopup(twitterProvider); */

export const doSignOut = () => auths.signOut();

export const doPasswordReset = email => auths.sendPasswordResetEmail(email);

// export const doPasswordResetFunction = async (email) => { 
//   try {
//     const validation = await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/reset_password?email=${email}`, {
//       headers: {
//         'Content-Type': 'application/json',
//       }
//     })
//     return validation;
//   } catch (error) {
//     throw error.response
//   }
// }

export const doSendEmailVerification = () =>
  auths.currentUser.sendEmailVerification({
    url: process.env.REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
  });

export const doPasswordUpdate = password =>
  auths.currentUser.updatePassword(password);

export const fetchingUser = () =>
  auths.onAuthStateChanged();


export const onAuthStateChanged = (additionalData) => {
  auths.onAuthStateChanged(async userAuth => {
    if (userAuth) {
      const userRef = await createUserProfileDocument(userAuth, additionalData);
      const token = userAuth.getIdToken();
      userRef.onSnapshot((snapShot) => {
        return ({
          token,
          ...snapShot.data(),
          id: snapShot.id,
        })

      })
    } else {      
      return userAuth
    }
  });
}

export const filterAdminLawyer = async (params) => {
  const {
    page,
    name,
    firstLastName,
    secondLastName,
    email,
    specialty,
    membershipType,
    membershipStatus,
    startDate,
    lastDate,
  } = params 
  try {
    const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/lawyers/lawyer_user_search`,
        {
          params: {
            name: name ? name : null,
            firstLastName: firstLastName ? firstLastName : null,
            secondLastName: secondLastName ? secondLastName : null,
            email: email ? email : null,
            type: membershipType ? membershipType : null,
            specialty: specialty ? specialty : null,
            page,
            membershipStatus: membershipStatus ? membershipStatus : null,
            startDate,
            lastDate,
          }
        }
      )
    
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const createAdminLawyer = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/lawyers/create_lawyer_user`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const filterAdminLawfirm = async (params) => {
  const {
    page,
    lawFirmName,
    specialty,
    membershipType,
    email,
  } = params
  try {
    const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/law_firm/lawyer_firm_search`,
        {
          params: {
            page,
            officeName: lawFirmName ? lawFirmName : null,
            specialty: specialty ? specialty : null,
            type: membershipType ? membershipType : null,
            email: email ? email : null,
          }
        }
      )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const verifyAuthUser = async (email) => {
  let data = {
    email:email
  }
  try {
    const response = await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/auth/get_user_auth`, data );
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const updateRoleAuthUser = async (id) => {
  try {
    var data = JSON.stringify({"lawyeruser":true}); 
    var config = {
      method: 'put',
      url: `${process.env.REACT_APP_FIREBASE_URLSERVICE}/auth/create_role?id=${id}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    const response = await axios(config)
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const updateRoleAuthUserClient = async (id) => {
  try {
    var data = JSON.stringify({"client":true}); 
    var config = {
      method: 'put',
      url: `${process.env.REACT_APP_FIREBASE_URLSERVICE}/auth/create_role?id=${id}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    const response = await axios(config)
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const createAdminLawfirm = async (body) => {
  console.log('body', body);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/law_firm/create_lawyer_firm`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const filterAdminContactCenter = async (params) => {
  const { page, completeName, email, signUpDate, searchEvery } = params
  try {
    let response
    if (searchEvery) {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/user_contact_center/paging_contact_center_user?page=${page}&names=&email=&createdAt=`
      )
    } else {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/user_contact_center/paging_contact_center_user?page=${page}&names=${completeName}&email=${email}&createdAt=${signUpDate}`
      )
    }
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const createAdminContactCenter = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/user_contact_center/create_user_contact_center`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const updateAdminContactCenter = async (body, id) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/user_contact_center/update_user_contact_center?id=${id}`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const filterAdminClient = async (params) => {
  const { page, name, lastName, email, signUpDate, searchEvery } = params
  try {
    let response
    if (searchEvery) {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/client/get_paging_client?page=${page}`
      )
    } else {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/client/get_paging_client?page=${page}&lastName=${lastName}&email=${email}&createAt=${signUpDate}&name=${name}`
      )
    }
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const decryptPassword = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/lawyers/decrypt_password`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data.data;
  } catch (error) {
    throw error.response
  }
}

export const getPagingNotifications = async (uid, page ,type) => {
  if(type == 'lawyer'){
    try {
      let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/notifications?lawyerUid=${uid}&page=${page}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  }else if(type == 'client'){
    try {
      let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/notifications_client?clientUid=${uid}&page=${page}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const getMenuNotifications = async (uid, type) => {
  if (type == 'lawyer') {
    try {
      let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/notifications_alerts?lawyerUid=${uid}`)
      return response.data;
    } catch (error) {
      throw error;
    }
  } else if (type == 'client') {
    try {
      let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/notifications_alerts?clientUid=${uid}`)
      return response.data;
    } catch (error) {
      throw error;
    }
 }   
}

export const getHelpCommunityData = async () => { 
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/total_questions_lawyer_user`
    )
    return response.data;
  } catch (error) {
    throw error.response

  }
}

export const createQuestions = async (body) => {
  try {
    let response = await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/create_question`, body)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const publishAnswer = async (questionId, body) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/create_response?idQuestion=${questionId}`, body)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getListQuestions = async (search, page) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/search_question?search=${search}&page=${page}`) 
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAllQuestions = async(page) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/paging_questions?page=${page}`) 
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getMoreAnsweredQuestions = async() => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/more_answered_questions`) 
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getListAnswers = async(idQuestion, page) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/response_paging?idQuestion=${idQuestion}&page=${page}`) 
    return response.data;
  } catch (error) {
    console.log('error', error.response);
    throw error.response;
  }
}

export const updateCheckCommunity = async (type) => {
  try {
    let response = await axios.put(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/community/update_lawyeruser_community?type=${type}`)
    return response.data;
  } catch (error) {
    throw error.response;
  }
}

export const getPagingLawyers = async (role, page, specialty, subSpecialty, state) => {
  try {
    let queryParams = `${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/lawyerUsers`
    let objectQuery = {
      role, page, specialty, subSpecialty, state
    }
    let keys = Object.keys(objectQuery).filter(k => objectQuery[k]);
    let values = Object.values(objectQuery).filter(v => v);
    for (let i = 0; i < keys.length; i++) {
      if (i == 0 && values[i]) {
        queryParams = queryParams + '?'
      }
      queryParams = values[i] ? queryParams + (i != 0 ? '&' : '') + `${keys[i]}=` + `${values[i]}` : queryParams;
    }
    let response = await axios.get(queryParams)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getLaywerUserById = async (uid) => {
  return new Promise((resolve, reject) => {
    firestore.collection('lawyerUsers').doc(uid).get()
      .then(laywerUserById => {
        if (laywerUserById.data()) {
          return resolve(laywerUserById.data())
        } else {
          return reject('lawyerUserById is undefined')  
        }
      })
      .catch(error => {
        return reject(error)
      })
  })
}

export const getLaywerUserEmpty =  async(role) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/lawyerEmpty?role=${role}`)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getPagingMessages = async (lawyerUid, page) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/messages?lawyerUid=${lawyerUid}&page=${page}`)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getPagingOpinions = async (lawyerUid, page) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/opinions?lawyerUid=${lawyerUid}&page=${page}`)
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const createBillingLaywer = async(lawyerUid, data) => {
  console.log('data', data)
  try {
    let response = await firestore.collection('lawyerUsers').doc(lawyerUid).collection('billingData').doc(data.rfc).set(data)
    let response2 = await firestore.collection('lawyerUsers').doc(lawyerUid).set({ membershipData: {idStripe: data.idStripe, idFacturapi:data.idFacturapi,fingerprints:[] } }, { merge: true })
    return response;
  } catch (error) {
    throw error;
  }
}

export const updateInfoBillingLaywer = async(lawyerUid, data) => {
  console.log('data', data)
   try {
     let response = await firestore.collection('lawyerUsers').doc(lawyerUid).collection('billingData').doc(data.rfc).set(data,  { merge: true })
     return response;
   } catch (error) {
     throw error;
   }
 }

 
 export const updateStatusMembership = async(lawyerUid) => {
   try {
     let response = await firestore.collection('lawyerUsers').doc(lawyerUid).set({statusMembership: "active"},  { merge: true })
     return response;
   } catch (error) {
     throw error;
   }
 }
 export const createFingerprintStripe = async(lawyerUid, fingerprint) => {
   console.log("en fire", fingerprint)
  try {
    let response = await firestore.collection('lawyerUsers').doc(lawyerUid).set({ membershipData: {fingerprints: firebase.firestore.FieldValue.arrayUnion(fingerprint)
 } }, { merge: true })

 console.log("en fireout", response)

    return response;
  } catch (error) {
    throw error;
  }
}

export const getBillingLaywer = async(lawyerUid) => {
  try {
    let data = {}
    let response = await firestore.collection('lawyerUsers').doc(lawyerUid).collection('billingData').get()
    response.forEach(doc => {
      data = doc.data()
    })
    
    return data;
  } catch (error) {
    throw error;
  }
}


const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) {
    return
  };

  const userRef = firestore.doc(`client/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    const createAt = new Date()

    try {
      await userRef.set({
        role: 'cliente',
        displayName,
        email,
        createAt,
        ...additionalData
      })
    } catch (error) { 
      
    }
  }
  return userRef;
}

export const uploadImage = async (elem, routeName, subRouteName, uid) => {
  try {
    let getUrl
    if (elem) { 
      let sPhoto = `CA_${Math.floor(Math.random() * 10)}_${8}`;
      await storage
        .ref(`profileImage/${uid}/${routeName}/${subRouteName}/${sPhoto}`)
        .put(elem)
        .on(
          'state_changed',
          snapShot => {},
          err => {},
          async () => {
            try {
              getUrl = await storage.ref(`profileImage/${uid}/${routeName}/`).child(`${subRouteName}/${sPhoto}`).getDownloadURL()
              console.log('getUrl ', getUrl);
              
            } catch (error) {
              console.log(error);
            }
          }
        )
    }
  } catch (error) {
    throw error;
  }
}

export const uploadPDF = async (blob, uid, idProposal) => {
  return new Promise(async (resolve, reject) => {
    try {
      let getUrl
      if (blob) { 
        let namePdf = idProposal;
        await storage
          .ref(`PDFs/${uid}/${idProposal}/${namePdf}`)
          .put(blob)
          .on(
            'state_changed',
            snapShot => {},
            err => {},
            async () => {
              try {
                getUrl = await storage.ref(`PDFs/${uid}/${idProposal}/`).child(`${namePdf}`).getDownloadURL()
                resolve(getUrl)
              } catch (error) {
                console.log(error);
              }
            }
          )
      }
    } catch (error) {
      throw error;
    }

  })
}





export const createMessage = (data, lawyerUui, clientUui = '') => {
  return new Promise((resolve, reject) => {
    const createdAt = new Date();

    let values = {
      name: data.name,
      phone: data.phone,
      email: data.email,
      client: clientUui,
      save: false,
      infoAdicional: data.infoAdicional,
      client: clientUui,
      lawyer: lawyerUui,
      message: {
        read: false,
        creaded: createdAt,
        text: data.description
      }
    }

    const updatedVideos = firebase.firestore.FieldValue.arrayUnion(values);

    firestore.collection(`messages`).doc(lawyerUui).set({ total: updatedVideos }, { merge: true })

  })
}

export const createNotification = async (fromUser, type, uidTo, nameTo, uidtype) => {
  console.log('createNotification')
  const createdAt = new Date();
  const userRef = firestore.collection(`notifications`).doc(uidTo);
  let data = {}
  switch (type) {

    case 'messages':
      data = {
        type: type,
        creaded: createdAt,
        featured: false,
        read: false,
        to: uidTo,
        from: fromUser,
        uidMessage: uidtype,
        message: {
          title: nameTo,
          text: 'Te ha contactado.',
          instruction: 'Para dar seguimiento y cerrar una cita, da click en  esta notificación.',
        }
      }
      break;

    case 'Opinion':
      data = {
        type: type,
        creaded: createdAt,
        featured: false,
        read: false,
        to: uidTo,
        from: fromUser,
        uidOpinion: uidtype,
        message: {
          title: nameTo,
          text: 'Ha dejado una opinión de tus servicios.',
          instruction: 'Para ver la opinión, da click en esta notificación.',
        }
      }
      break;
    default:
      break;
  }
  try {
    await userRef.set(data)
  }
  catch (error) { }
}

/* Legal Matters */

export const getLegalMattersListByCategory = async (category) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/legal_matters/get_legal_matters_home?typeCategory=${category}`
    );
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const getLegalMattersListByFilter = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/legal_matters/get_paging_legal_matters?page=${params.page}${params.specialty ? `&specialty=${params.specialty}` : ''}`,
    );
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const getLegalMattersListById = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/legal_matters/get_legal_matters_by_id?id=${params.id}&state=${params.state ? params.state : 'CDMX'}`,
      );
      if (response) {
        return resolve(response.data);
      } else {
        return reject('no data')
      }
    } catch (error) {
      return reject(error.response)
    }
  })
}

/* Lawyers and Firms - landingClient */

export const getLawyersLanding = async (params) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/paging/get_lawyer_user_landing?role=${params.role}${params.state ? `&state=${params.state}` : ''}`,
    );
    return response.data;
  } catch (error) {
    throw error.response
  }
}

/* Send app opinion - landingClient */

export const sendAppOpinion = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/client/create_opinion_client`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}


/* Articles */

export const getPagedArticles = async (params) => {
  const { limit, page, category, createdAt, title, status } = params;
  try {
    let response
    if(category) {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_paging_article_public?limit=${limit}&page=${page}&category=${category}`);
    } else {
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_paging_article_public?limit=${limit}&page=${page}`);
    }
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const doGetFeaturedArticle = async () => {
  try {
    let response
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_featured_article`);
    return response.data;
  } catch (error) {
    throw error.response
  }
}
export const getRecentArticles = async () => {
  try {
    let response
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_recent_articles`);
    return response.data;
  } catch (error) {
    throw error.response
  }
}
export const getMostReadArticles = async () => {
  try {
    let response
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_most_read_articles`);
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const getArticleById = async (id) => {
  try {
    let response
      response = await axios.get(
        `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/get_article_by_id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const updateArticleById = async (id, body) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/article/update_article?id=${id}`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

/* ECONOMIC PROPOSALS */ 

export const getPagedProposals = async (params) => {
  const { uid, createdAt, status, source, page, limit } = params;
  try {
    const url = `${process.env.REACT_APP_FIREBASE_URLSERVICE}/economic_proposal/get_economic_proposal_filter?limit=${limit}&page=${page}&uid=${uid}${createdAt ? `&date=${createdAt}`:''}${status ? `&status=${status}` : ''}${source ? `&source=${source}` : ''}`
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const updateProposalById = async (body, idProposal, uid) => {  
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/economic_proposal/update_economic_proposal?uid=${uid}&idProposal=${idProposal}`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}

export const createProposal = async (body, uid) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_FIREBASE_URLSERVICE}/economic_proposal/create_economic_proposal?uid=${uid}`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*"
        }
      }
    )
    return response.data;
  } catch (error) {
    throw error.response
  }
}


/*
MODO REF
export const createMessage = async (data , lawyerUui, clientUui=false  ) =>{
  const createAt = moment().format('DD-MM-YYYY HH:mm ');
  const userRef = firestore.collection(`messages`);
  let clientId = '';
  if(!clientUui){
    clientId =firestore.doc('client/' + clientUui)
  }
  let lawyer = firestore.doc('lawyerUsers/' + lawyerUui)
  try{
    await userRef.add(( {name: data.name,
      phone: data.phone,
      email: data.email,
      client:  clientId,
      save: false,
      infoAdicional: data.infoAdicional,
      client: clientUui, 
      lawyer: lawyer,
      message:{
      read: false,
      creaded: createAt, 
      text: data.description
      }} ))
      .then(res=> firestore.collection(`messages`).doc(res.id).set({id:res.id},{merge: true } ))
  }
  catch(error){}

} */



/* 

  
    export const checkVerifyEmail = () => 
  auth.onAuthStateChanged();
// *** Merge Auth and DB User API *** //
export const onAuthStateChanged = () =>{
  auth.onAuthStateChanged(async userAuth =>{
    if(userAuth){
      const userRef = await createUserProfileDocument(userAuth);
      userRef.onSnapshot(snapShot =>{
        return({
          ...snapShot.data(),
          id: snapShot.id,

        })
       
      })
    }else{
      return userAuth
    }
    
    
  });
}





// Open supscription
export const onAuthUserListener = (next, fallback) =>
  auth.onAuthStateChanged(authUser => {
    if (authUser) {
      user(authUser.uid)
        .once('value')
        .then(snapshot => {
          const dbUser = snapshot.val();

          // default empty roles
          if (!dbUser.roles) {
            dbUser.roles = {};
          }

          // merge auth and db user
          authUser = {
            uid: authUser.uid,
            email: authUser.email,
            emailVerified: authUser.emailVerified,
            providerData: authUser.providerData,
            ...dbUser,
          };

          next(authUser);
        });
    } else {
      fallback();
    }
  });

// *** User API ***

export const user = uid => db.ref(`users/${uid}`);

export const users = () => db.ref('users');

// *** Message API ***

export const message = uid => db.ref(`messages/${uid}`);

export const messages = () => db.ref('messages');




export const createUserProfileDocument = async (userAuth, additionalData)=> {
  if(!userAuth) return;
  
  const userRef = firestore.doc(`client/${userAuth.uid}`);
  const snapShot = await userRef.get();
  if(!snapShot.exists){
    const { displayName, email } = userAuth;
    const createAt = new Date()

    try {
      await userRef.set({
        displayName,
        email,
        createAt,
        ...additionalData
      })
    } catch (error) {}
  }
  return userRef;
}
 */

export default firebase;